<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI SLIDE</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT SLIDE</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT SLIDE</h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <b-row>
            <b-col lg="6">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input
                  v-model="mData.dataForm.tieu_de"
                  :disabled="mData.viewMode == 'detail'"
                ></el-input>
              </el-form-item>

              <el-form-item label="Đường dẫn">
                <el-input
                  type="text"
                  v-model="mData.dataForm.duong_dan"
                  :disabled="mData.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
              <b-row>
                <b-col lg="6">
                  <el-form-item label="Hiệu lực từ ngày">
                    <el-date-picker
                      v-model="mData.dataForm.hien_thi.hieu_luc_tu"
                      type="datetime"
                      format="dd/MM/yyyy HH:mm:ss"
                      :disabled="mData.viewMode == 'detail'"
                      @input="$forceUpdate()"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col lg="6">
                  <el-form-item label="Đến ngày">
                    <el-date-picker
                      v-model="mData.dataForm.hien_thi.hieu_luc_den"
                      type="datetime"
                      format="dd/MM/yyyy HH:mm:ss"
                      :disabled="mData.viewMode == 'detail'"
                      @input="$forceUpdate()"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
              <el-form-item
                label="Thứ tự hiển thị"
                v-if="mData.viewMode == 'detail' || mData.viewMode == 'update'"
                style="width: 200px"
                prop="thu_tu"
              >
                <el-select
                  v-model="mData.dataForm.thu_tu"
                  :disabled="mData.viewMode == 'detail'"
                  @change="forceUpdateUI"
                >
                  <el-option
                    v-for="item in mData.thu_tu_array"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  @change="fn_hideSlide"
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.hien_thi.an"
                  >Ẩn Slide</el-checkbox
                >
              </el-form-item>
            </b-col>
            <b-col lg="6">
              <el-form-item label="Giới thiệu">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.gioi_thieu"
                  class="slideText"
                  :disabled="mData.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
              <el-form-item label="Điều kiện" prop="hien_thi.dieu_kien">
                <el-select
                  v-model="mData.dataForm.hien_thi.dieu_kien"
                  multiple
                  @change="fn_changeDieuKien"
                  placeholder="Chọn điều kiện"
                  :disabled="mData.viewMode === 'detail'"
                >
                  <el-option
                    v-for="item in mData.dieuKien"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <!-- thêm ảnh, video -->
          <b-row>
            <b-col cols="12" md="4">
              <div class="image-logo">
                <div class="video__btnGroup d-flex">
                  <div
                    class="media-btn"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <i class="far fa-image"></i>
                    <label for="uploadImageLogo">Thêm logo</label>
                    <input
                      type="file"
                      id="uploadImageLogo"
                      accept="image/*"
                      @change="fn_uploadImageLogo"
                      @click="fn_onInputClick"
                      style="display: none"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    v-show="mData.dataForm.anh_nho_btn_show"
                    @click="fn_remove('anh_nho')"
                    style="margin-left: 5px"
                  ></el-button>
                </div>
                <div class="show-image">
                  <div v-if="upLoadLogoFinish" class="show-logo-loading">
                    <Circle4
                      style="width: 40px !important; height: 40px !important"
                    ></Circle4>
                  </div>
                  <img
                    width="100%"
                    :src="mData.dataForm.anh_nho_url"
                    v-show="mData.dataForm.anh_nho_show"
                    alt="ảnh logo slide"
                    style="width: 150px; object-fit: cover"
                    class="img-logo"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div class="video-slide">
                <div class="video__btnGroup d-flex">
                  <div
                    class="media-btn"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <i class="fab fa-youtube"></i>
                    <label for="uploadVideo">Thêm video</label>
                    <input
                      type="file"
                      id="uploadVideo"
                      accept="video/*"
                      @change="fn_uploadVideo"
                      @click="fn_onInputClick"
                      style="display: none"
                      :disabled="mData.viewMode == 'detail'"
                      ref="uploadVideos"
                    />
                  </div>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    v-show="mData.dataForm.video_btn_show"
                    @click="fn_remove('video')"
                    style="margin-left: 5px"
                  ></el-button>
                </div>
                <div class="show-video">
                  <div v-if="upLoadVideoFinish">
                    <Circle4 class="show-video-loading"></Circle4>
                  </div>
                  <Media
                    :kind="'video'"
                    :controls="true"
                    :src="mData.dataForm.video_url"
                    v-show="mData.dataForm.video_show"
                    :style="{
                      'max-height': '200px',
                      width: '100%',
                      'object-fit': 'cover',
                    }"
                    class="upload-video"
                  >
                  </Media>
                </div>
              </div>
            </b-col>

            <b-col cols="12" md="4">
              <div class="image-slide">
                <div class="video__btnGroup d-flex">
                  <div
                    class="media-btn"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <i class="fas fa-image"></i>
                    <label for="uploadImageSlide">Thêm ảnh</label>
                    <input
                      type="file"
                      id="uploadImageSlide"
                      accept="image/*"
                      @change="fn_uploadImageSlide"
                      @click="fn_onInputClick"
                      style="display: none"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    v-show="mData.dataForm.anh_btn_show"
                    @click="fn_remove('anh')"
                    style="margin-left: 5px"
                  ></el-button>
                </div>
                <div class="show-image">
                  <div v-if="upLoadImageFinish">
                    <Circle4
                      style="width: 40px !important; height: 40px !important"
                      class="show-image-loading"
                    ></Circle4>
                  </div>

                  <img
                    :src="mData.dataForm.anh_url"
                    alt="ảnh nền slide"
                    v-show="mData.dataForm.anh_show"
                    style="max-height: 200px; width: 100%; object-fit: cover"
                  />
                </div>
              </div>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addSlide()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormSlide";
import Media from "@dongido/vue-viaudio";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Media,
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      hideSlide: false,
      loading: true,
      upLoadImageFinish: false, // upload image slide thành công
      upLoadLogoFinish: false, // upload logo slide thành công
      upLoadVideoFinish: false, // upload video slide thành công
      mData: {
        spinVideo: false,
        spinImage: false,
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        dieuKien: MethodService.copyObject(DataForm.dieuKien),
        validForm: MethodService.copyObject(DataForm.validForm),
        total: "",
        thu_tu_array: [],
        thu_tu_current: "",
      },
    };
  },
  methods: {
    // lấy số lượng tối đa slide để trường thu_tu tự động +1 khi tạo slide mới thành công
    async fn_getTotal() {
      try {
        const response = await mushroom.ldp_slide.listAsync();
        this.mData.total = response.meta.total;
        response.result.forEach((item) => {
          this.mData.thu_tu_array.push({
            value: item.thu_tu,
            label: item.thu_tu,
          });
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.ldp_slide.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,tieu_de,gioi_thieu,anh_id,anh_nho_id,video_id,duong_dan,thu_tu,hien_thi",
        });
        this.mData.dataForm = response.result;
        this.mData.thu_tu_current = response.result.thu_tu;
        console.log("slide chi tiết:", this.mData.dataForm);

        // đẩy thông tin ngày hiển thị vào datePicker
        // let array = [];
        // array.push(
        //   this.mData.dataForm.hien_thi.hieu_luc_tu,
        //   this.mData.dataForm.hien_thi.hieu_luc_den
        // );
        // this.mData.dataForm.hien_thi_ngay = array;

        // kiểm tra có id của ảnh, logo(anh_nho), video rồi mới đẩy dữ liệu
        if (this.mData.dataForm.anh_nho_id) {
          this.mData.dataForm.anh_nho_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.anh_nho_id)
            .build();
          this.mData.dataForm.anh_nho_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.anh_nho_btn_show = true)
            : (this.mData.dataForm.anh_nho_btn_show = false);
        }
        if (this.mData.dataForm.anh_id) {
          this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.anh_id)
            .build();
          this.mData.dataForm.anh_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.anh_btn_show = true)
            : (this.mData.dataForm.anh_btn_show = false);
        }
        if (this.mData.dataForm.video_id) {
          this.mData.dataForm.video_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.video_id)
            .build();
          this.mData.dataForm.video_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.video_btn_show = true)
            : (this.mData.dataForm.video_btn_show = false);
        }
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // thêm slide mới
    async fn_addSlide() {
      const ldp_slide_object = {
        tieu_de: this.mData.dataForm.tieu_de,
        gioi_thieu: this.mData.dataForm.gioi_thieu,
        anh_id: this.mData.dataForm.anh_id,
        anh_nho_id: this.mData.dataForm.anh_nho_id,
        video_id: this.mData.dataForm.video_id,
        duong_dan: this.mData.dataForm.duong_dan,
        thu_tu: this.mData.total + 1,
        hien_thi: {
          an: this.hideSlide,
          hieu_luc_tu: this.mData.dataForm.hien_thi.hieu_luc_tu,
          hieu_luc_den: this.mData.dataForm.hien_thi.hieu_luc_den,
          dieu_kien: this.mData.dataForm.hien_thi.dieu_kien,
        },
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          console.log(ldp_slide_object);
          if (
            this.mData.dataForm.anh_id == undefined &&
            this.mData.dataForm.video_id == undefined
          ) {
            window.toastr.warning("Cần upload ảnh hoặc video");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.hien_thi.dieu_kien.length == 0) {
            window.toastr.warning("Cần thêm điều kiện");
            MethodService.stopLadda();
          } else {
            try {
              await mushroom.ldp_slide.createAsync(ldp_slide_object);
              MethodService.stopLadda();
              this.fn_resetForm();
              this.fn_resetDataForm();
              window.toastr.success("Thêm mới Slide thành công");
              this.$router.push({
                name: "DanhSachSlide",
              });
            } catch (error) {
              console.log(error);
              console.log(this.$refs.myForm.$el);
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Đã có lỗi xảy ra");
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_changeDieuKien(item) {
      this.mData.dataForm.hien_thi.dieu_kien = item;
      console.log(this.mData.dataForm.hien_thi.dieu_kien);
      this.forceUpdateUI();
    },
    fn_hideSlide(event) {
      // console.log("change");
      // this.hideSlide = !this.hideSlide;
      this.mData.dataForm.hien_thi.an = event;
    },

    // thao tác ảnh
    async fn_uploadImageSlide() {
      this.mData.spinImage = true;
      this.upLoadImageFinish = true;
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadImageSlide").files[0], // required
        });
        console.log("image: ", res.result);
        this.$forceUpdate();
        this.mData.dataForm.anh_id = res.result;
        this.mData.dataForm.anh_show = true;
        this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();

        this.mData.dataForm.anh_btn_show = true;
        this.mData.spinImage = false;
        setTimeout(() => {
          this.upLoadImageFinish = false;
        }, 8000);
      } catch (error) {
        console.log(error);
      }
    },
    async fn_uploadImageLogo() {
      this.upLoadLogoFinish = true;
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadImageLogo").files[0], // required
        });
        console.log("logo: ", res.result);
        this.$forceUpdate();
        this.mData.dataForm.anh_nho_id = res.result;
        this.mData.dataForm.anh_nho_show = true;
        this.mData.dataForm.anh_nho_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();

        this.mData.dataForm.anh_nho_btn_show = true;
        setTimeout(() => {
          this.upLoadLogoFinish = false;
        }, 3000);
      } catch (error) {
        console.log(error);
      }
    },

    // thao tác video
    async fn_uploadVideo() {
      this.mData.spinVideo = true;
      this.upLoadVideoFinish = true;
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadVideo").files[0], // required
        });
        console.log("video: ", res.result);
        this.$forceUpdate();
        this.mData.dataForm.video_id = res.result;
        this.mData.dataForm.video_show = true;
        this.mData.dataForm.video_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();
        this.mData.dataForm.video_btn_show = true;
        setTimeout(() => {
          this.upLoadVideoFinish = false;
        }, 4000);
      } catch (e) {
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        }
        this.mData.spinVideo = false;
      }
    },

    // xóa ảnh và video vừa upload
    async fn_remove(item) {
      if (item == "video") {
        this.mData.dataForm.video_show = false;
        this.mData.dataForm.video_url = "";
        this.mData.dataForm.video_id = null;
        this.mData.dataForm.video_btn_show = false;
      }
      if (item == "anh") {
        this.mData.dataForm.anh_show = false;
        this.mData.dataForm.anh_url = "";
        this.mData.dataForm.anh_id = null;
        this.mData.dataForm.anh_btn_show = false;
      }
      if (item == "anh_nho") {
        this.mData.dataForm.anh_nho_show = false;
        this.mData.dataForm.anh_nho_url = "";
        this.mData.dataForm.anh_nho_id = null;
        this.mData.dataForm.anh_nho_btn_show = false;
      }

      this.$forceUpdate();
    },

    // reset lại thẻ input khi vừa xóa ảnh/video
    fn_onInputClick(event) {
      event.target.value = "";
    },

    // cập nhật slide
    async fn_update() {
      const ldp_slide_object = {
        id: this.$router.currentRoute.params.id,
        tieu_de: this.mData.dataForm.tieu_de,
        gioi_thieu: this.mData.dataForm.gioi_thieu,
        anh_id: this.mData.dataForm.anh_id,
        anh_nho_id: this.mData.dataForm.anh_nho_id,
        video_id: this.mData.dataForm.video_id,
        duong_dan: this.mData.dataForm.duong_dan,
        thu_tu: this.mData.dataForm.thu_tu,
        hien_thi: {
          an: this.mData.dataForm.hien_thi.an,
          hieu_luc_tu: this.mData.dataForm.hien_thi.hieu_luc_tu,
          hieu_luc_den: this.mData.dataForm.hien_thi.hieu_luc_den,
          dieu_kien: this.mData.dataForm.hien_thi.dieu_kien,
        },
      };
      if (!this.mData.dataForm.anh_id && !this.mData.dataForm.video_id) {
        window.toastr.warning("Cần upload ảnh hoặc video");
        MethodService.stopLadda();
      } else if (!this.mData.dataForm.anh_nho_id) {
        window.toastr.warning("Cần upload ảnh logo");
        MethodService.stopLadda();
      } else if (this.mData.dataForm.hien_thi.dieu_kien.length == 0) {
        window.toastr.warning("Cần thêm điều kiện");
        MethodService.stopLadda();
      } else {
        try {
          // cập nhật thứ tự của slide bị lấy mất thứ tự
          const responseOld = await mushroom.ldp_slide.listAsync({
            filters: ["thu_tu=" + this.mData.dataForm.thu_tu],
          });
          const ldp_slide_object_old = {
            id: responseOld.result[0].id,
            thu_tu: this.mData.thu_tu_current,
          };
          await mushroom.ldp_slide.partialUpdateAsync(ldp_slide_object_old);

          // cập nhật thứ tự mới cho slide đang thao tác cập nhật
          const response = await mushroom.ldp_slide.partialUpdateAsync(
            ldp_slide_object
          );
          if (response.result == this.$router.currentRoute.params.id) {
            window.toastr.success("Cập nhật Slide thành công");
            MethodService.stopLadda();
            this.$router.push({
              name: "DanhSachSlide",
            });
          } else {
            window.toastr.warning("Dữ liệu không thay đổi");
            MethodService.stopLadda();
          }
        } catch (error) {
          MethodService.stopLadda();
          console.error("Có lỗi: %o", error);
          if (e.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (e.code === 2) {
            window.toastr.error("Máy chủ không phản hồi");
          } else window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },

    // quay lại danh sách slide
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    fn_resetDataForm() {
      this.mData.dataForm.thu_tu = undefined;
      this.mData.dataForm.anh_id = null;
      this.mData.dataForm.anh_show = false;
      this.mData.dataForm.anh_btn_show = false;
      this.mData.dataForm.anh_url = undefined;
      this.mData.dataForm.anh_nho_show = false;
      this.mData.dataForm.anh_nho_id = null;
      this.mData.dataForm.anh_nho_url = undefined;
      this.mData.dataForm.anh_nho_btn_show = false;
      this.mData.dataForm.anh_nho_url = undefined;
      this.mData.dataForm.video_show = false;
      this.mData.dataForm.video_id = null;
      this.mData.dataForm.video_url = undefined;
      this.mData.dataForm.video_btn_show = false;
    },
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    await this.fn_getTotal();

    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemSlide") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietSlide") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatSlide") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .slideText textarea {
  height: 208px;
}
label {
  margin-bottom: 0;
}
.uploadImage {
  position: relative;
}
.show-video,
.show-image {
  min-height: 60px;
}
.show-image,
.img-logo,
.upload-video {
  position: relative;
}
.show-image-loading,
.show-video-loading {
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translate(-50%, -50%);
}
.show-logo-loading,
.show-video-loading,
.show-image-loading {
  width: 40px !important;
  height: 40px !important;
}
.show-logo-loading {
  position: absolute;
  top: 26%;
  left: 9%;
  transform: translate(-26%, -9%);
  z-index: 1;
}
::v-deep .el-upload--text {
  display: none;
}
::v-deep .flower-spinner {
  background-color: transparent;
  margin-top: 33px;
}
.video {
  border: 1px solid #dcdfe6;
  padding: 10px;
  border-radius: 3px;
  &__btnGroup {
    margin-bottom: 5px;
  }
}
.deactiveBtn {
  border: 1px solid #d3d4d6 !important;
  background-color: #f4f4f5 !important;
  color: rgb(109, 109, 109) !important;
  &:hover {
    background-color: #f4f4f5 !important;
    color: rgb(109, 109, 109) !important;
  }
  label,
  i {
    cursor: no-drop !important;
  }
}
.media-btn {
  padding: 5px 15px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
}
</style>
